<template>
  <div id="BlockedReport">
    <loading v-if="loadingRender"></loading>
    <panel Title="گزارش مسدودی‌ها" Des="از طریق این فرم میتوانید گزارشی از مسدودی حساب‌های خود را مشاهده نمائید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-lock"></i>
          گزارش مسدودی‌ها
        </h6>
      </template>
      <template slot="content">
        <div class="blocked-report-filters" id="Date">
          <p class="blocked-report-hint">حساب خود را انتخاب کنید.</p>
          <div class="blocked-report-filters__row">
            <div class="blocked-report-field">
              <label class="blocked-report-label" for="cmbTaahodat"
                >انتخاب حساب</label
              >
              <select
                v-if="IsLoad"
                @change="GetReport"
                name="cmbTaahodat"
                id="cmbTaahodat"
                class="form-control Pointer"
                v-model="Resultcmb"
              >
                <option v-if="this.IsLoad == false" value="-2">
                  || در حال بارگذاری ، منتظر بمانید ... ||
                </option>
                <option selected value="-1">-- انتخاب حساب --</option>
                <option
                  v-for="item in this.ListModel"
                  :key="item.id"
                  :value="item.id"
                >
                  <span>{{ item.vcodeDesNo }} </span>
                </option>
              </select>
            </div>
            <!-- <div class="col-md-2 col-12 mt-3">
                    <input type="button" name="" value="جستجو" class="btn btn-success mt-2 w-100" @click="GetReport();$ResetTimer()" />
                </div> -->
          </div>
        </div>
        <div class="blocked-report-cards" dir="rtl">
          <p v-if="!rows.length" class="blocked-report-cards__empty">
            اطلاعاتی یافت نشد
          </p>
          <template v-else>
            <div class="blocked-report-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control blocked-report-cards__search"
                placeholder=" جستجو"
                aria-label="جستجو در مسدودی‌ها"
              />
            </div>
            <p
              v-if="filteredCardRows.length === 0"
              class="blocked-report-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="blocked-report-cards__list">
              <article
                v-for="(row, index) in pagedCardRows"
                :key="(row.id || 'row') + '-' + index"
                class="blocked-report-card"
              >
                <div class="blocked-report-card__header">
                  <strong class="blocked-report-card__name">{{
                    row.familyNameVamGirande ||
                    row.sharh ||
                    row.vcodePas ||
                    'مسدودی'
                  }}</strong>
                  <span
                    v-if="row.tarix"
                    class="blocked-report-card__badge"
                    >{{ row.tarix }}</span
                  >
                </div>
                <div class="blocked-report-card__amount">
                  <span dir="ltr">{{
                    cardValue(row.mablaghMasdodNemodan)
                  }}</span>
                  <small>مبلغ مسدودی</small>
                </div>
                <div class="blocked-report-card__fields">
                  <div
                    v-if="row.sharh"
                    class="blocked-report-card__field"
                  >
                    <span>توضیحات</span>
                    <strong>{{ row.sharh }}</strong>
                  </div>
                  <div
                    v-if="row.vCode"
                    class="blocked-report-card__field"
                  >
                    <span>شماره تسهیلات</span>
                    <strong dir="ltr">{{ row.vCode }}</strong>
                  </div>
                  <div
                    v-if="row.vcodePas"
                    class="blocked-report-card__field"
                  >
                    <span>شماره پس‌انداز</span>
                    <strong dir="ltr">{{ row.vcodePas }}</strong>
                  </div>
                  <div class="blocked-report-card__field">
                    <span>مبلغ تسهیلات</span>
                    <strong dir="ltr">{{ cardValue(row.mablaghVam) }}</strong>
                  </div>
                  <div class="blocked-report-card__field">
                    <span>مبلغ قسط</span>
                    <strong dir="ltr">{{
                      cardValue(row.mablaghGhestVam)
                    }}</strong>
                  </div>
                </div>
              </article>
            </div>
            <div
              v-if="filteredCardRows.length > cardPerPage"
              class="blocked-report-cards__pager"
            >
              <button
                type="button"
                class="blocked-report-cards__pager-btn"
                :disabled="cardPage <= 1"
                @click="cardPage = cardPage - 1"
              >
                قبلی
              </button>
              <span class="blocked-report-cards__pager-info">
                صفحه {{ cardPage }} از {{ cardPageCount }}
              </span>
              <button
                type="button"
                class="blocked-report-cards__pager-btn"
                :disabled="cardPage >= cardPageCount"
                @click="cardPage = cardPage + 1"
              >
                بعدی
              </button>
            </div>
          </template>
        </div>

        <div class="blocked-report-table-view">
          <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            :classes="classes"
          >
            <template slot="sort-asc-icon">
              <i class="fa fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
              <i class="fa fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
              <i class="fa fa-sort"></i>
            </template>
            <template slot="mablaghGhestVam" slot-scope="props">
              {{
                props.row.mablaghGhestVam == null
                  ? '-'
                  : props.row.mablaghGhestVam
              }}
            </template>
            <template slot="mablaghVam" slot-scope="props">
              {{
                props.row.mablaghVam == null ? '-' : props.row.mablaghVam
              }}
            </template>
            <template slot="empty-results">
              <p class="text-right">اطلاعاتی یافت نشد</p>
            </template>
          </vue-bootstrap4-table>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  data() {
    return {
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_ListMasdodi: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListMasdodi',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModel: null,
      IsLoad: false,
      Resultcmb: null,
      ResultcmbZemanat: null,
      ListModelZemanat: null,
      rows: [],
      cardSearch: '',
      cardPage: 1,
      cardPerPage: 10,
      listData: null,
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'توضیحات',
          name: 'sharh',
        },
        {
          label: 'شماره تسهیلات',
          name: 'vCode',
        },
        {
          label: 'شماره پس انداز',
          name: 'vcodePas',
        },
        {
          label: 'مشخصات',
          name: 'familyNameVamGirande',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط تسهیلات',
          name: 'mablaghGhestVam',
        },
        {
          label: 'تاریخ',
          name: 'tarix',
        },
        {
          label: 'مبلغ مسدودی',
          name: 'mablaghMasdodNemodan',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
    }
  },
  computed: {
    filteredCardRows() {
      const q = (this.cardSearch || '').trim().toLowerCase()
      if (!q) return this.rows
      return this.rows.filter((row) => {
        const hay = [
          row.row,
          row.sharh,
          row.vCode,
          row.vcodePas,
          row.familyNameVamGirande,
          row.mablaghVam,
          row.mablaghGhestVam,
          row.tarix,
          row.mablaghMasdodNemodan,
        ]
          .filter((v) => v != null && v !== '')
          .join(' ')
          .toLowerCase()
        return hay.includes(q)
      })
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage
      return this.filteredCardRows.slice(start, start + this.cardPerPage)
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      )
    },
  },
  watch: {
    rows() {
      this.cardPage = 1
    },
    cardSearch() {
      this.cardPage = 1
    },
  },
  components: {
    panel,
    NetPaCard,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData()
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 2)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data
        this.Resultcmb = data[0].id
      })
      .finally(() => {
        this.GetReport()
      })
  },
  methods: {
    cardValue(val) {
      if (val == null || val === '') return '—'
      return val
    },
    GetReport() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaIdPas', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('VcodeID', this.Resultcmb == -1 ? null : this.Resultcmb)
      this.DataAxios_ListMasdodi.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_ListMasdodi).then((data) => {
        if (data.length) {
          let info
          let list = []
          for (let index = 0; index < data.length; index++) {
            info = data[index]
            info['row'] = index + 1
            list.push(info)
          }
          this.rows = this.$FormatMablaghGrid(list)
          this.loadingRender = false
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
          this.config.pagination = false
          this.rows = []
          this.loadingRender = false
        }
      })
    },
  },
}
</script>
<style scoped>
.blocked-report-filters {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.blocked-report-hint {
  margin: 0 0 0.85rem;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.7;
}

.blocked-report-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.blocked-report-field {
  display: flex;
  flex: 0 1 16rem;
  flex-direction: column;
  max-width: 16rem;
  min-width: 10rem;
  text-align: right;
}

.blocked-report-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.blocked-report-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.blocked-report-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

@media (max-width: 767px) {
  .blocked-report-field {
    flex: 1 1 100%;
    max-width: none;
    min-width: 0;
  }
}

.blocked-report-cards {
  display: none;
}

.blocked-report-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.blocked-report-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.blocked-report-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.blocked-report-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.blocked-report-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.blocked-report-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.blocked-report-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.blocked-report-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.blocked-report-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.blocked-report-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.blocked-report-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.blocked-report-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.blocked-report-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.blocked-report-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.blocked-report-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.blocked-report-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.blocked-report-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.blocked-report-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.blocked-report-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .blocked-report-cards {
    display: block;
  }

  .blocked-report-table-view {
    display: none;
  }
}
</style>
